module.exports = __webpack_public_path__ + "static/media/speaker4.574a1f6f.png";